import * as React from 'react';
import {getAmountWithDecimalDigits} from "../../CommonFunctions";

export const paymentPlanUpdatedRefundModal = (returnPremium: any, monthlyPremium: any, previousMonthlyPremium: any, instalmentsNotPaidOff: boolean, renewalPremium: any): React.ReactNode => {
    if(instalmentsNotPaidOff) { // NOSONAR
        return (
            <div className="font-weight-extra-light">
                <p>You currently pay <span className="font-weight-semi-bold">
                    {getAmountWithDecimalDigits(previousMonthlyPremium)}
                </span> a month.</p>
                <p>The refund of <span className="font-weight-semi-bold">
                    {getAmountWithDecimalDigits(returnPremium)}
                </span> has reduced your remaining monthly
                    payments to <span className="font-weight-semi-bold">
                        {getAmountWithDecimalDigits(monthlyPremium)} / month</span>.
                </p>
                {renewalPremium &&
                    (<div className="font-weight-semi-bold">
                        <p>
                            Your next year's renewal price will be {getAmountWithDecimalDigits(renewalPremium)}&nbsp;
                        </p>
                        <p>
                            Please check your renewal tile for further details
                        </p>
                    </div>)
                }
            </div>
        )
    } else {
        return (
            <div>
                <p className="font-weight-extra-light">We’ve saved your changes, and we’ll refund you{' '}
                <span className="font-weight-bold">{getAmountWithDecimalDigits(returnPremium)}.</span>{' '}
                    Please allow two days for it to arrive.
                </p>
                {renewalPremium &&
                    (<div className="font-weight-semi-bold">
                        <p>
                            Your next year's renewal price will be {getAmountWithDecimalDigits(renewalPremium)}&nbsp;
                        </p>
                        <p>
                            Please check your renewal tile for further details
                        </p>
                    </div>)
                }
            </div>
        );
    }
}

export const paymentPlanUpdatedAdditionalPremiumModal = (monthlyPaymentSpreadAmount: any, monthlyPremium: any, previousMonthlyPremium: any, renewalPremium: any): React.ReactNode => {
    return (
        <div className="font-weight-extra-light">
            <p>You currently pay <span className="font-weight-semi-bold">
                    {getAmountWithDecimalDigits(previousMonthlyPremium)}
                </span> a month.
            </p>
            <p>The additional cost of <span className="font-weight-semi-bold">
                        {getAmountWithDecimalDigits(monthlyPaymentSpreadAmount)}
                    </span> has increased your remaining monthly payments to <span className="font-weight-semi-bold">
                {getAmountWithDecimalDigits(monthlyPremium)} / month.</span>
            </p>
            {renewalPremium &&
                (<div className="font-weight-semi-bold">
                    <p>
                        Your next year's renewal price will be {getAmountWithDecimalDigits(renewalPremium)}&nbsp;
                    </p>
                    <p>
                        Please check your renewal tile for further details
                    </p>
                </div>)
            }
        </div>
    )
}

export const paymentSuccessfulAdditionalPremiumModal = (additionalPremium: any, cardNumber: string, modalContent: any, agreeToReuseCardDetails: boolean | null, renewalPremium: any): React.ReactNode => {
    return (
        <>
            <p className="mb-0 font-weight-extra-light">
                <span className="font-weight-semi-bold">
                    {getAmountWithDecimalDigits(additionalPremium)}
                </span> has been debited from your credit card ending <span className="font-weight-semi-bold">
                {cardNumber.slice(-4)}</span>{" "}
                {modalContent}
            </p>
            {renewalPremium &&
                (<div className="font-weight-semi-bold">
                    <p>
                        Your next year's renewal price will be {getAmountWithDecimalDigits(renewalPremium)}&nbsp;
                    </p>
                    <p>
                        Please check your renewal tile for further details
                    </p>
                </div>)
            }
            <p>
                Please allow a couple of minutes for the payment to be updated in your account.
            </p>
            {agreeToReuseCardDetails && (
                <p className="mb-0 font-weight-extra-light">
                    Your future payments will now be taken from this card.
                </p>
            )}
        </>
    )
}

export const paymentSuccessfulAdditionalPremiumMonthlyModal = (upfrontPaymentAmount: any, monthlyPaymentSpreadAmount: any, cardNumber: string, modalContent: any, agreeToReuseCardDetails: boolean | null, renewalPremium: any): React.ReactNode => {
    return (
        <>
            <p className="mb-0 font-weight-extra-light">
                <span className="font-weight-semi-bold">
                    {getAmountWithDecimalDigits(upfrontPaymentAmount)}
                </span> has been debited from your credit card ending <span className="font-weight-semi-bold">
                {cardNumber.slice(-4)}</span>{" "}
                {modalContent}
            </p>
            {renewalPremium &&
                (<div className="font-weight-semi-bold">
                    <p>
                        Your next year's renewal price will be {getAmountWithDecimalDigits(renewalPremium)}&nbsp;
                    </p>
                    <p>
                        Please check your renewal tile for further details
                    </p>
                </div>)
            }
            <p>
                Please allow a couple of minutes for the payment to be updated in your account.
            </p>
            {agreeToReuseCardDetails && (
                <p className="mb-0 font-weight-extra-light">
                    Your future payments will now be taken from this card.
                </p>
            )}
            <p className="mb-0 font-weight-extra-light">
                The remaining {getAmountWithDecimalDigits(monthlyPaymentSpreadAmount)} has been added to
                your monthly payments.
            </p>
        </>
    )
}

export const paymentSuccessfulRefundModal = (returnPremium: any, modalContent: any, renewalPremium: any): React.ReactNode => {
    return (
        <>
            <p className="font-weight-extra-light">
                We’ve saved your changes, and we’ll refund you <span className="font-weight-semi-bold">
                {getAmountWithDecimalDigits(returnPremium)}</span>{" "}
                {modalContent}{" "}
            </p>
            {renewalPremium &&
                (<div className="font-weight-semi-bold">
                    <p>
                        Your next year's renewal price will be {getAmountWithDecimalDigits(renewalPremium)}&nbsp;
                    </p>
                    <p>
                        Please check your renewal tile for further details
                    </p>
                </div>)
            }
            <p>
                Please allow two days for it to arrive.
            </p>
        </>
    )
}
